import React from "react";
import classNames from "classnames";
import styles from "./shot-map-shot-selector.module.scss";
import {observer} from "mobx-react";

export const ShotMapShotSelectorTimeAndType = observer(({selectedShot, shouldRenderTypeShot, isShallowShotMapView}) => {
  const {isGoalType} = selectedShot;
  const typeShotName = isShallowShotMapView && isGoalType && selectedShot.shortViewName ? selectedShot.shortViewName : selectedShot.outcome?.name;

  return (
    <div className={classNames(styles.time, {[styles.time_and_type]: shouldRenderTypeShot})}>
      {selectedShot.time}
      {shouldRenderTypeShot && <span className={classNames(styles.type, {[styles.is_goal]: isGoalType})}>{typeShotName}</span>}
    </div>
  )
});